import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class UsernameCheckService {

  private checkUsernameUrl ='/api/username/checkUsername';

  constructor(private http:HttpClient) { }

  checkUsername(username,type='all') {

    const options = username ?
      {
        params: new HttpParams()
          .set('username', username)
          .set('type',type)
      } : {};

    return this.http.get(this.checkUsernameUrl,options);
  }
}
